import { render, staticRenderFns } from "./AsyncCase.vue?vue&type=template&id=4c240180&scoped=true&"
import script from "./AsyncCase.vue?vue&type=script&lang=js&"
export * from "./AsyncCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c240180",
  null
  
)

export default component.exports